import { useQuery } from '@tanstack/vue-query'
import { getListingRequestStatusCounts } from '../listingRequestsEndpoints'
import { listingRequestKeys } from '../listingRequestsQueryKeys'

// One read feeds every sidebar badge, every queue header subtitle, and the
// pipeline KPI row — replaces the per-queue `limit: 1` list reads. Exposed
// cross-module from `index.ts` so the sidebar subscribes to the same key the
// lifecycle mutations invalidate; badges refresh without an extra fetch.
export function useListingRequestStatusCountsQuery() {
  return useQuery({
    queryKey: listingRequestKeys.statusCounts(),
    queryFn: getListingRequestStatusCounts,
  })
}
